import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ProjectExternalCameraModel } from '../../models/project-external-camera.model';

export const ProjectExternalCameraActions = createActionGroup({
  source: 'PROJECT_EXTERNAL_CAMERA',
  events: {
    'Reset to Initial state': emptyProps(),
    'Reset list': emptyProps(),
    'Set loading on filters change': emptyProps(),
    'Reset state on last page': emptyProps(),

    'Load external camera brands': emptyProps(),
    'Load external camera brands success': props<{
      brands: ProjectExternalCameraModel.CameraBrand[],
    }>(),
    'Load external camera brands fail': emptyProps(),

    'Load filtered external cameras': emptyProps(),
    'Load filtered external cameras success': props<{
      cameras: ProjectExternalCameraModel.CameraDocument[],
    }>(),
    'Load filtered external cameras fail': emptyProps(),

    'Set selected Camera': props<{
      selectedCamera: ProjectExternalCameraModel.CameraDocument | null;
      count?: number;
    }>(),

    'Set external camera filters': props<{ filters: ProjectExternalCameraModel.API.FilterParams | null }>(),

    'Load external camera types': emptyProps(),
    'Load external camera types success': props<{
      types: string[],
    }>(),
    'Load external camera types fail': emptyProps(),
  },
});
